import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { CookieBanner } from "./components/CookieBanner";
import { WhatsAppButton } from "./components/WhatsAppButton";
import Home from "./pages/Home";
import LegalPage from "./pages/LegalPage";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";

const SmoothScroll = () => {
  const location = useLocation();
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.085, smoothWheel: true, wheelMultiplier: 0.9 });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, []);
  useEffect(() => {
    if (!location.state?.scrollTo) window.__lenis?.scrollTo(0, { immediate: true });
  }, [location.pathname, location.state]);
  return null;
};

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <SmoothScroll />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/impressum" element={<LegalPage slug="impressum" />} />
          <Route path="/datenschutz" element={<LegalPage slug="datenschutz" />} />
          <Route path="/agb" element={<LegalPage slug="agb" />} />
          <Route path="/widerruf" element={<LegalPage slug="widerruf" />} />
          <Route path="/cookies" element={<LegalPage slug="cookies" />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
        <CookieBanner />
        <Toaster
          position="bottom-center"
          toastOptions={{ style: { background: "#121215", color: "#f8f9fa", border: "1px solid rgba(212,175,55,0.35)", fontFamily: "Manrope, sans-serif" } }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
